<template>
  <div id="request-suspension-page" class="viewport viewport-with-top-nav viewport-compact">

    <TopNav></TopNav>

    <div class="display-1 py-3">{{$t('LoanRequestSuspensionPage.title')}}</div>
    <div v-if="loading" class="pt-4 mt-2">
      <div class="card card-shadow card-rounded border-0 mb-4">
        <div class="card-body py-5 text-center">
          <spinner></spinner>
        </div>
      </div>
    </div>
    <template v-else-if="!calculation.suspendable">
      <p class="text-preserve-lines mb-3">{{$t('LoanRequestSuspensionPage.suspensionNotAvailable')}}</p>
    </template>
    <template v-else>
      <p class="text-preserve-lines mb-3">{{$t('LoanRequestSuspensionPage.suspensionNotice')}}</p>

      <div class="card card-shadow border-0 mb-4">

        <div class="card-body">
          <div class="row">
            <div class="col-6 form-group">
              <div class="small text-muted">{{$t('LoanRequestSuspensionPage.paymentDate')}}</div>
              <div>
                <strong>{{ $d(calculation.paymentDate) }}</strong>
              </div>
            </div>
            <div class="col-6 form-group">
              <div class="small text-muted">{{$t('LoanRequestSuspensionPage.paymentAmount')}}</div>
              <div>
                <strong>{{ $n(calculation.notPaid, 'currency') }}</strong>
              </div>
            </div>
            <div class="col-6 form-group">
              <div class="small text-muted">{{$t('LoanRequestSuspensionPage.newPaymentDate')}}</div>
              <div>
                <strong>{{ $d(calculation.newPaymentDate) }}</strong>
              </div>
            </div>
            <div class="col-6 form-group">
              <div class="small text-muted">{{$t('LoanRequestSuspensionPage.suspensionFee')}}</div>
              <strong>{{ $n(calculation.suspensionFee, 'currency') }}</strong>
            </div>
          </div>
          <div id="button-request-suspension" class="btn btn-primary btn-block" @click="this.requestSuspension">
            {{ $t('LoanRequestSuspensionPage.requestSuspension') }}
          </div>
        </div>
      </div>
    </template>

    <div class="flex-grow-1"></div>

  </div>
</template>

<script>
    import TopNav from '@shared/components/TopNav'

    export default {
    name: 'LoanRequestSuspensionPage',
    components: { TopNav },
    data() {
      return {
        loading: true,
        calculation: null,
        url: `/api/loans/${this.$route.params.reference}/installments/suspend`
      }
    },
    mounted () {
      this.$http.get(this.url).then(response => {
          this.calculation = response.data
          this.loading = false
        })
    },
    methods: {
      requestSuspension() {
        this.loading = true
        this.$http.post(this.url)
        .then(response => {
          this.$router.back()
        })
        .catch(error => {
          this.loading = false
          return error
        })
      }
    }
  }
</script>
